import { RootState } from '@/App/store';

export const selectForgotPassword = (state: RootState) => state.forgotPassword;
